export interface TypeDropdownProps {
  // add props here
}

export const isEventTypeSelected = (type: EventType | null): boolean => {
  return !!type;
};

export const aiTypeDropdownId = 'AITypeDropdown';
export const typeDropdownId = 'TypeDropdown';

export interface EventTypes {
  allTypes: EventType[];
  selectedType?: EventType;
  aiType?: EventType;
  isAITypeLoading?: boolean;
}

export interface EventType {
  hashedID: string;
  name: string;
}
